var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.782.552a.522.522 0 0 0-.23.23l-.05.093v6.51l.051.093c.062.115 5.548 5.597 5.708 5.704.168.113.426.225.62.268.342.077.779.036 1.09-.102.278-.123.408-.246 2.81-2.654 2.595-2.602 2.503-2.501 2.626-2.888a1.719 1.719 0 0 0-.005-1.109c-.131-.396-.009-.263-3.039-3.298C8.776 1.81 7.534.584 7.485.558c-.084-.044-.17-.045-3.36-.044C1.187.515.845.519.782.552M9.71 4.171c1.472 1.472 2.691 2.709 2.711 2.748a.845.845 0 0 1-.008.691c-.068.137-4.66 4.732-4.795 4.798a.77.77 0 0 1-.702.003c-.055-.029-1.154-1.111-2.757-2.712L1.493 7.035V1.493h5.542L9.71 4.171M3.921 3.152a1.012 1.012 0 0 0-.492.277.972.972 0 0 0 0 1.402c.498.499 1.311.349 1.618-.298.069-.147.075-.176.075-.403 0-.227-.006-.256-.075-.403a1.014 1.014 0 0 0-1.126-.575",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/union.37dadd4ed8afff42699263efa8e0d3e1.svg";
export { ForwardRef as ReactComponent };